"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserCapabilities = (function () {
    function BrowserCapabilities() {
    }
    BrowserCapabilities.prototype.hasLifecycleSuspension = function () {
        return false;
    };
    BrowserCapabilities.prototype.hasNativeParentalPin = function () {
        return false;
    };
    BrowserCapabilities.prototype.hasExternalAppsDisplay = function () {
        return false;
    };
    BrowserCapabilities.prototype.hasVolumeControl = function () {
        return false;
    };
    BrowserCapabilities.prototype.hasExternalAppsLaunch = function () {
        return false;
    };
    return BrowserCapabilities;
}());
exports.BrowserCapabilities = BrowserCapabilities;
